import { API_AUTH } from "./common";

const LoaiTaiSanApi = {
  combo: ({ trangThai = "" } = {}) =>
    API_AUTH.get(
      `quanlytaisan/danh-sach-loai-tai-san-combo?trangThai=${trangThai}`,
      {},
    ),

  combo1: ({ trangThai = "" } = {}) =>
    API_AUTH.get(
      `quanlytaisan/danh-sach-loai-tai-san-combo1?trangThai=${trangThai}`,
      {},
    ),

  themMoi: ({
    MaHangHoa,
    TenHangHoa,
    TrangThaiHangHoa,
    LoaiThanhToan,
    ListThuocTinhTaiSan = [],
  }) =>
    API_AUTH.post(`quanlytaisan/them-moi-loai-tai-san`, {
      MaHangHoa,
      TenHangHoa,
      TrangThaiHangHoa,
      LoaiThanhToan,
      ListThuocTinhTaiSan,
    }),
};

export default LoaiTaiSanApi;
